import C from "../constantes";
import Sales from "../../../services/sales";
import { EventBus } from "../../../event-bus";
import param from "../../../services/param";
import { cents } from "../../../filters/number";
import Contract from "../../../services/contracts";
//Promotion code MAE50
import { mapGetters } from "vuex";

export default {
  props: ["contract", "newSalesType"],
  data() {
    return {
      loading: undefined,
      taxRecharge: undefined,
      rechargeValue: 0,
      recharge: 1,

      taxRechargeMan: undefined,
      rechargeValueMan: 0,
      rechargeMan: 1,

      taxRechargeAut: undefined,
      rechargeValueAut: 0,
      rechargeAut: 1,

      taxIdNumber: undefined,
      detalhePlano: undefined,
      recVp: undefined,
      couponValue: '',
      couponError: ''
    };
  },

  created() {
    this.mostrarAlerta(this.planId)
  },

  mounted() {
    this.contract.plan.planId = this.$route.query.planId;
    if (this.contract.rechargeValue) {
      this.recharge =
        this.rechargeMan =
        this.rechargeAut =
          this.contract.rechargeValue / this.multiple;
    } else {
      this.contract.rechargeValue = this.multiple;
      this.recharge = 1;
    }

    if (this.planHasRecharge(this.planId) && !this.promoId) {
      let promise = Sales.calculateRechargeRate({
        value: this.recharge * this.multiple,
        planId: this.contract.plan.planId || 21,
        contractId: 0,
      }).then((response) => {
        this.taxRecharge = response.taxTotal;
        this.rechargeValue = response.valueTotal;

        this.taxRechargeAut = response.taxTotal;
        this.rechargeValueAut = response.valueTotal;

        this.taxRechargeMan = response.taxTotal;
        this.rechargeValueMan = response.valueTotal;

        this.contract.taxRecharge = this.taxRecharge;
      });
      this.$store.dispatch("loading", promise);
    } else {
      this.firstValueRecharge(1);
    }

    this.contract.lcFlag = false;

    var chave;

    if (this.contract.plan.planId == 21) {
      this.chave = "LIMITE_CREDITO_PF";
    } else {
      if (this.contract.plan.planId == 31) {
        this.chave = "LIMITE_CREDITO_PJ";
      }
    }

    //recupera o valor base
    param
      .getGeneralParameter({
        key: this.chave,
      })
      .then((res) => {
        this.contract.limitCredit = res.value.replace(/[^0-9]/g, "");
      });
  },

  computed: {
    ...mapGetters(["getPromotionCurrent"]),
    sameTax() {
      return this.newAdhesionTax == this.newVehicleTax;
    },
    planId() {
      return this.$route.query.planId || this.contract.plan.planId;
    },
    CO() {
      return C;
    },
    isCaminhoParana() {
      return !!this.$parent.lead;
    },
    multiple() {
      return this.getMultipleRecharge(this.planId);
    },
    plan() {
      return this.$store.getters.getPlanById(this.planId);
    },
    newAdhesionTax() {
      return this.$store.getters.getNewAdhesionTax(this.planId);
    },
    newVehicleTax() {
      return this.$store.getters.getNewVehicleTax(this.planId);
    },
    guaranteeTax() {
      return this.$store.getters.getGuaranteeTax(this.planId);
    },
    linkRntrcTax() {
      return this.$store.getters.getLinkRntrcTax(this.planId);
    },
    bankAccountOptions() {
      return this.$store.getters.getBankAccountOptions(this.planId);
    },
    creditCardOptions() {
      return this.$store.getters.getCreditCardOptions(this.planId);
    },
    bankBillOption() {
      return this.$store.getters.getBankBillOption(this.planId);
    },
    qtdGratis() {
      return Math.floor(this.rechargeValue / 20000);
    },
    checkPromoSenff() {
      if (sessionStorage.getItem("promoCheck") == "#FR01") return true;
    },
    promoId() {
      return this.$route.query.promoId;
    },
    coupon: {
      get() {
        return this.couponValue;
      },
      set(value) {
        this.couponError = '';
        this.couponValue = value ? value.replace(/[^a-zA-Z0-9]/g, '') : '';
      }
    },
  },

  methods: {
    firstValueRecharge(unit) {
      if (unit < 1) return;

      var req = {
        planId: this.planId,
        promoId: this.promoId,
      };

      this.loading = Sales.firstValueRecharge(req)
        .then((response) => {
          var multiple = response.firstTaxe.rechargeValue;
          this.loading = Sales.calculateRechargeRate({
            value: unit * multiple,
            planId: this.contract.plan.planId || 21,
            contractId: 0,
          }).then((response) => {
            this.recharge = unit;
            this.taxRecharge = response.taxTotal;
            this.rechargeValue = response.valueTotal;

            if (this.planId == 22) {
              this.rechargeValueAut = 5000;
              this.rechargeValueMan = 5000;
              this.taxRechargeAut = 750;
              this.taxRechargeMan = 750;
            }
            if (this.planId == 32) {
              this.rechargeValueAut = 25000;
              this.rechargeValueMan = 25000;
              this.taxRechargeAut = 2500;
              this.taxRechargeMan = 2500;
            }

            this.contract.taxRecharge = this.taxRecharge;
            this.contract.rechargeValue = this.rechargeValue
          });
          // this.$store.dispatch("loading", promise);
        })
        .catch((err) => {
          return false;
        });
    },

      mostrarAlerta(newVal) {
      
            try {
              Contract.getDetailPlanVp(newVal).then(resp =>{
                console.log(resp, "Detalhe do plano 2");
                this.recVp = resp.plan.recVp;
                console.log(this.recVp, "recVp");
              })
            } catch (error) {
              console.error('Erro na requisição: ', error);
              alert('Erro na requisição: ' + error.message);
            }
    },

    calculate(unit) {
      if (unit < 1) return;

      let promise = Sales.calculateRechargeRate({
        value: unit * this.multiple,
        planId: this.planId || 21,
        contractId: 0,
      }).then((r) => {
        this.recharge = unit;
        this.taxRecharge = r.taxTotal;
        this.contract.taxRecharge = this.taxRecharge;
        this.contract.rechargeValue = this.rechargeValue = r.valueTotal;
      });

      this.$store.dispatch("loading", promise);
    },

    calculateManParanaWay(unit) {
      if (unit < 1) return;

      let promise = Sales.calculateRechargeRate({
        value: unit * this.multiple,
        planId: this.$parent.lead.typeTaxId == "COMPANY" ? 37 : 35,
        contractId: 0,
      }).then((r) => {
        this.rechargeMan = unit;
        this.taxRechargeMan = r.taxTotal;
        this.contract.rechargeValue = this.rechargeValueMan = r.valueTotal;
      });

      this.$store.dispatch("loading", promise);
    },

    calculateAutParanaWay(unit) {
      if (unit < 1) return;

      let promise = Sales.calculateRechargeRate({
        value: unit * this.multiple,
        planId: this.$parent.lead.typeTaxId == "COMPANY" ? 38 : 36,
        contractId: 0,
      }).then((r) => {
        this.rechargeAut = unit;
        this.taxRechargeAut = r.taxTotal;
        this.contract.rechargeValue = this.rechargeValueAut = r.valueTotal;
      });

      this.$store.dispatch("loading", promise);
    },

    nextParana(plan) {
      this.taxRecharge =
        plan == "man" ? this.taxRechargeMan : this.taxRechargeAut;
      this.rechargeValue =
        plan == "man" ? this.rechargeValueMan : this.rechargeValueAut;
      this.contract.rechargeValue = this.rechargeValue;

      this.$parent.nextParana(plan);
    },

    validateAll() {
      this.contract.tax = this.taxRecharge;
      let vm = this;
      let promise = this.$validator.validateAll().then((r) => {
        if (this.planId == 2) {
          let taxId = this.taxIdNumber.replace(/[.\-\/]/g, "").toUpperCase();
          if (taxId.length == 14) {
            this.contract.plan.planId = 3;
            this.$router.replace({
              name: "adhesion",
              query: { planId: 3, taxIdNumber: taxId },
            });
          } else {
            this.$router.replace({
              name: "adhesion",
              query: { planId: 2, taxIdNumber: taxId },
            });
          }
        }
      }).then(() => {
        // Valida cupom se estiver preenchido
        const coupon = vm.getCoupon();
        if (coupon) {
          return Sales.validateCoupon(coupon).then(res => {
            if (!res.valid) {
              vm.couponError = 'Cupom inválido';
              return Promise.reject('Cupom inválido');
            }
          }).catch(err => {
            vm.couponError = 'Cupom inválido';
            return Promise.reject('Cupom inválido');
          });
        }
      });
      //this.$store.dispatch("loading", promise); TODO
      return promise;
    },
    getCoupon() {
      return this.couponValue || null;
    },

    cleanErrors() {
      EventBus.$emit("cleanErrors");
    },

    limiteFormatado: function () {
      return cents(this.contract.limitCredit);
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/common/adhesion/choose-plan.js